import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { toUserMessage } from '@/services/api/errors'

/**
 * Per-route boundary. A crash inside one feature must not blank the whole shell —
 * the operator keeps their navigation and can move on to something else.
 */
export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  const notFound = isRouteErrorResponse(error) && error.status === 404

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <div className="mb-3 flex size-10 items-center justify-center rounded-full bg-danger-subtle text-danger">
        <AlertTriangle className="size-5" aria-hidden />
      </div>
      <h1 className="text-lg font-semibold text-fg">
        {notFound ? 'Page not found' : 'This page ran into a problem'}
      </h1>
      <p className="mt-1 max-w-md text-sm text-fg-muted">
        {notFound
          ? 'The address you followed does not match any page in this application.'
          : toUserMessage(error)}
      </p>
      <div className="mt-4 flex gap-2">
        <Button onClick={() => navigate(-1)}>Go back</Button>
        <Button variant="primary" onClick={() => navigate('/dashboard')}>
          Dashboard
        </Button>
      </div>
    </div>
  )
}
